export const DIALOG_KINDS = {
  ERROR: 'warning',
  INFO: 'info',
};
